/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/explicit-function-return-type */

import { Container } from "inversify"
import { IapComponentDataSource } from "../../../entidades/builder/component/domain/iapComponentDataSource"
import { IServiceDataUpdate } from "../../../entidades/builder/dataupdate/application/IServiceDataUpdate"
import { dataUpdate } from "../../../entidades/builder/dataupdate/domain/dataUpdate"
import { TYPES } from "../../domain/types"
import HelperLoading from "./HelperLoading"

const isoDateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d*)?(?:[-+]\d{2}:?\d{2}|Z)?$/

export const doOperationData = async (container: Container | undefined, componentDataSource: IapComponentDataSource, data: dataUpdate[], transactionOperation:boolean) => {
  return await new Promise<boolean>((resolve, reject) => {
    if (container) {
      const _srv = container.get<IServiceDataUpdate>(TYPES.DATAUPDATE_REPOSITORY)
      HelperLoading.showSaving()
      const operationData = JSON.parse(JSON.stringify(data))
      _srv.update(componentDataSource.applicationId ?? -1, componentDataSource.applicationVersion ?? -1, componentDataSource.componentId, componentDataSource.id, operationData,transactionOperation)
      .then(response => {
        if (response) {
          resolve(true)
        }
        else {
          resolve(false)
        }
      })
        .catch(() => {
          reject(false);
        })
        .finally(() => {
          HelperLoading.hideSaving()
        })
    }
  });
}


export default { doOperationData }
